module.exports = __webpack_public_path__ + "img/311052e2444e4a8ac089edef5fbd23de.png";